module.exports = __webpack_public_path__ + "media/images/homes/mail-fa53a7e35384368913ffbc321ca51e9b.svg";